// Vite Plugin SSR (Vike) config shared by server + client
// Ensure required pageContext values are available client-side.

export const passToClient = [
  'urlPathname',
] as const;
